import type { HttpMethod } from "./types";

const proxyPath = import.meta.env.VITE_SANDBOX_PROXY_PATH;
const apiUrl = import.meta.env.VITE_SANDBOX_API_URL;

export const SANDBOX_API_BASE =
  proxyPath ?? apiUrl ?? "https://api.sandbox.thredd.com";

export const METHOD_COLORS: Record<
  HttpMethod,
  { fg: string; bg: string; border: string }
> = {
  GET: { fg: "#135200", bg: "#f0ffe1", border: "#b7eb8f" },
  POST: { fg: "#2f54eb", bg: "#f0f5ff", border: "#adc6ff" },
  PUT: { fg: "#b05800", bg: "#fff8d4", border: "#ffe58f" },
  DELETE: { fg: "#ff4d4f", bg: "#fff2f0", border: "#ffccc7" },
  PATCH: { fg: "#391085", bg: "#f9f0ff", border: "#d3adf7" },
};

export const HISTORY_LIMIT = 50;

export const STORAGE_KEYS = {
  user: "thredd-sandbox-user",
  credentials: "thredd-sandbox-credentials",
  history: "thredd-sandbox-history",
  tourDismissed: "thredd-sandbox-tour-dismissed",
  team: "thredd-sandbox-team",
  themeMode: "thredd-sandbox-theme-mode",
};

export const FREE_EMAIL_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "hotmail.com",
  "hotmail.co.uk",
  "outlook.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "tutanota.com",
  "gmx.com",
  "fastmail.com",
  "zoho.com",
  "yandex.com",
];

export const COMPETITOR_DOMAINS = [
  "marqeta.com",
  "galileo.io",
  "galileofinancialtechnologies.com",
  "adyen.com",
  "stripe.com",
  "highnote.io",
  "lithic.com",
  "paymentology.com",
  "nium.com",
  "episodesix.com",
  "i2cinc.com",
  "fispayments.com",
  "wirecard.com",
];

export const SANDBOX_THEME_CSS_VAR_KEYS = {
  light: "thredd-sandbox-light",
  dark: "thredd-sandbox-dark",
};

export const SALESFORCE_COUNTRIES = [
  "United States",
  "Canada",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Indian Ocean Territory",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Côte d’Ivoire",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong S.A.R., China",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao S.A.R., China",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "North Korea",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "U.S. Virgin Islands",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican",
  "Venezuela",
  "Vietnam",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export interface ErrorCodeEntry {
  code: number;
  descriptionKey: string;
  labelKey: string;
  reason: string;
}

export const ERROR_CODES: ErrorCodeEntry[] = [
  {
    code: 400,
    labelKey: "badRequest",
    descriptionKey: "400",
    reason: "Bad Request",
  },
  {
    code: 401,
    labelKey: "unauthorized",
    descriptionKey: "401",
    reason: "Unauthorized",
  },
  {
    code: 403,
    labelKey: "forbidden",
    descriptionKey: "403",
    reason: "Forbidden",
  },
  {
    code: 404,
    labelKey: "notFound",
    descriptionKey: "404",
    reason: "Not Found",
  },
  {
    code: 422,
    labelKey: "validationError",
    descriptionKey: "422",
    reason: "Unprocessable Entity",
  },
  {
    code: 429,
    labelKey: "tooManyRequests",
    descriptionKey: "429",
    reason: "Too Many Requests",
  },
  {
    code: 500,
    labelKey: "internalServerError",
    descriptionKey: "500",
    reason: "Internal Server Error",
  },
];
